import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import TopMenu from './Components/Layout/TopMenu';
import Home from './Components/Real_Estate/Home';
import Home2 from './Components/Real_Estate/Home2';
import Home3 from './Components/Real_Estate/Home3';
import Login from './Components/Login';
import PropertyList from './Components/Real_Estate/PropertyList';
import AnimatedBackground from './Components/Real_Estate/AnimatedBackground';

function App() {
  // scroll to top
  const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
    return null;
  };

  return (
    <>
      <div>
        <ScrollToTop />
        <AnimatedBackground />
        <TopMenu/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<><TopMenu /><Home /></>} />
          <Route path="/home2" element={<><TopMenu /><Home2 /></>} />
          <Route path="/home3" element={<><TopMenu /><Home3 /></>} />
          <Route path="/PropertyList" element={<><TopMenu /><PropertyList /></>} />
        </Routes>
      </div>
    </>
  );
}

export default App;
